import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { apiGetDetail, apiEditInfo, apiGetPage } from '../../request/api'
import { Modal, message } from 'antd';
import { useCustomData } from '../../pages/context/mineCustomDataProvider';

interface CheckPayOrderProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface PageData {
    orderStatus: string;
    payType: string;
    orderPrice: string;
    chooseCommodity: string;
    created_at: string;
    payAt: string;
    createdAt: string;
    id: string;
    informeUser: string;
    createdTime: string;
    launchCompany: string;
}


const CheckPayOrder: React.FC<CheckPayOrderProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [commodityInfo, setCommodityInfo] = useState<any>(null);
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [companyName, setCompanyName] = useState<string>('');
    const [pageInfo, setPageInfo] = useState<PageData>({
        orderStatus: '',
        payType: '',
        orderPrice: '',
        chooseCommodity: '',
        created_at: '',
        payAt: '',
        createdAt: '',
        informeUser: '',
        createdTime: '',
        launchCompany: '',
        id: '',
    });

    const statusTextMap: Record<string, Record<string, string>> = {
        待确认: {
            zh: '待确认',
            en: 'Pending Confirmation',
        },
        待支付: {
            zh: '待支付',
            en: 'Pending Payment',
        },
        汇款确认: {
            zh: '汇款确认',
            en: 'Remittance Confirmation',
        },
        已支付: {
            zh: '已支付',
            en: 'Paid',
        },
    };

    const { getValue } = useCustomData();
    const serviceInfo = getValue('serviceInfo');
    const serviceName = getValue('serviceName');
    const price = getValue('price');
    const orderNumber = getValue('orderNumber');
    const orderCreated = getValue('orderCreated');
    const orderStatus = getValue('orderStatus');
    const payAt = getValue('payAt');
    const payType = getValue('payType');
    const remittance = getValue('remittance');
    const orderInfo = getValue('orderInfo');
    const back = getValue('back');
    const companyName1 = getValue('companyName');


    useEffect(() => {
        apiGetDetail({
            tid: 'F32F1F7909694585A88B730331221DB3',
            languagecode: languageCode,
            id: data
        }).then(res => {
            const orderData = res.data.data;
            console.log(res)
            setPageInfo(orderData);
            apiGetDetail({
                tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
                languagecode: languageCode,
                id: orderData.chooseCommodity
            }).then(res2 => {
                setCommodityInfo(res2.data.data);
            });
            if (orderData.launchCompany) {
                apiGetDetail({
                    tid: 'E85B2C2CBF4C45FC89D7D540D35F780F',
                    languagecode: languageCode,
                    id: orderData.launchCompany
                }).then(res3 => {
                    setCompanyName(res3.data?.data?.componyName || '');
                });
            }
        }).catch(console.error);
    }, []);

    const goback = () => {
        handleViewChange('ordercenter')
    }
    return (
        <div className="CheckPayOrder">
            <div className='detail-back' style={{ color: themeColor }} onClick={goback}>
                <ArrowLeftOutlined />
                <div className='detail-back-right'> {back} </div>
            </div>
            <p className='mine-h3'>{serviceInfo}</p>
            <div className='check-order'>
                <div className='check-item'>
                    <p>{serviceName}</p>
                    <p className='check-item-p'>{commodityInfo?.commodityName || '-'}</p>
                </div>
                <div className='check-item'>
                    <p>{price}</p>
                    <p className='check-item-p'>{commodityInfo?.menberPrice || '-'}</p>
                </div>
                <div className='check-item'>
                    <p>{companyName1}</p>
                    <p className='check-item-p'>{companyName || '-'}</p>
                </div>
            </div>
            <p className='mine-h3'>{orderInfo}</p>
            <div className='check-order'>
                <div className='check-item'>
                    <p>{orderNumber}</p>
                    <p className='check-item-p'>{pageInfo.id}</p>
                </div>
                <div className='check-item'>
                    <p>{orderCreated}</p>
                    <p className='check-item-p'>{pageInfo.createdAt}</p>
                </div>
                <div className='check-item'>
                    <p>{orderStatus}</p>
                    <p className='check-item-p'> {statusTextMap[pageInfo.orderStatus]?.[languageCode] || pageInfo.orderStatus}</p>
                </div>
                {pageInfo.payAt == '' &&
                    <div className='check-item'>
                        <p>{payAt}</p>
                        <p className='check-item-p'>{pageInfo.payAt}</p>
                    </div>
                }
            </div>
            <p className='mine-h3'>{payType}</p>
            {pageInfo.payType == '0' && <p className='pay-p'>{remittance}</p>}
            {pageInfo.payType == '1' && <p className='pay-p'>PayPal</p>}


        </div>
    );
};

export default CheckPayOrder;